// The addresses a person reads their crossings under (02-escalation-and-grants.md
// § the approver; decision 0031 § 7): their own principal token, and for an
// admin also `admin`. The broker admits a person to nothing else, so the
// console asks under exactly these and merges what comes back.

import type { Bus } from "../../platform/bus.ts";
import {
  ADDRESS_ADMIN,
  escalationsListSubject,
  SERVICE,
  validAddress,
  type EscalationsReply,
} from "../../wire/guard.ts";

/** addresses is the person's own address and, for an admin, `admin`. */
export function addresses(principal: string, admin: boolean): string[] {
  const out = validAddress(principal) ? [principal] : [];
  if (admin) {
    out.push(ADDRESS_ADMIN);
  }
  return out;
}

/** listWaiting lists the escalations under every address, newest first. */
export async function listWaiting(bus: Bus, principal: string, admin: boolean): Promise<EscalationsReply> {
  const replies = await Promise.all(
    addresses(principal, admin).map((approver) =>
      bus.call<EscalationsReply>(SERVICE, escalationsListSubject(approver), undefined),
    ),
  );
  const escalations = replies.flatMap((r) => r.escalations);
  escalations.sort((a, b) => (a.opened < b.opened ? 1 : a.opened > b.opened ? -1 : 0));
  return { escalations };
}
